import React from "react";
import { QRCodeSVG } from "qrcode.react";
import "./Invoice.scss";

const Invoice = () => {
    const items = [
        {
            description: "Magazine Design",
            details: "Fusce imperdiet vivamus himenaeos orci enim viverra. Augue id ultricies tortor pharetra ridiculus lacus pretium.",
            price: 230,
            qty: 2,
        },
        {
            description: "Magazine Design",
            details: "Fusce imperdiet vivamus himenaeos orci enim viverra.",
            price: 230,
            qty: 2,
        },
        {
            description: "Magazine Design",
            details: "Fusce imperdiet vivamus himenaeos orci enim viverra. Augue id ultricies tortor pharetra ridiculus lacus pretium.",
            price: 230,
            qty: 2,
        },
        {
            description: "Magazine Design",
            details: "Fusce imperdiet vivamus himenaeos orci enim viverra.",
            price: 230,
            qty: 2,
        },
        {
            description: "Magazine Design",
            details: "Fusce imperdiet vivamus himenaeos orci enim viverra.",
            price: 230,
            qty: 2,
        },
        {
            description: "Magazine Design",
            details: "Fusce imperdiet vivamus himenaeos orci enim viverra. Augue id ultricies tortor pharetra ridiculus lacus pretium.",
            price: 230,
            qty: 2,
        },
        {
            description: "Magazine Design",
            details: "Fusce imperdiet vivamus himenaeos orci enim viverra.",
            price: 230,
            qty: 2,
        },
    ];

    const subTotal = items.reduce((acc, item) => acc + item.price * item.qty, 0);
    const tax = subTotal * 0.1;
    const total = subTotal + tax;

    return (
        <div className="invoice-container">
            <header className="invoice-header">
                <div>
                    <h1 className="invoice-title">INVOICE</h1>
                    <p className="invoice-number">Invoice No: #1987621</p>
                </div>
                <div className="invoice-address">
                    <div>
                        <h2 className="address-title">Invoice To:</h2>
                        <p>Studio Here</p>
                        <p>info@yourmail.com</p>
                        <p>Street Address Here, City</p>
                    </div>
                    <div>
                        <h2 className="address-title">From:</h2>
                        <p>Studio Here</p>
                        <p>+09 12345-678990</p>
                        <p>info@yourmail.com</p>
                    </div>
                </div>
            </header>
            <div className="invoice-table-wrapper">
                <table className="invoice-table">
                    <thead className="thead">
                        <tr>
                            <th>Qty</th>
                            <th>Item Description</th>
                            <th>Price</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item, index) => (
                            <tr key={index}>
                                <td>{item.qty}</td>
                                <td>
                                    <p className="item-description">{item.description}</p>
                                    <p className="item-details">{item.details}</p>
                                </td>
                                <td>${item.price.toFixed(2)}</td>
                                <td>${(item.qty * item.price).toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="invoice-summary">
                <p>Sub Total: ${subTotal.toFixed(2)}</p>
                <p>Tax (10%): ${tax.toFixed(2)}</p>
                <p className="total-amount">Total Amount: ${total.toFixed(2)}</p>
            </div>

            <footer className="invoice-footer">
                <span>Thank you very much</span>
                <QRCodeSVG value="Invoice Details" size={80} />
            </footer>
        </div>
    );
};

export default Invoice;
